import React from 'react'

import { clsx } from 'clsx'

import { Skeleton } from '@/app/[locale]/[ferry]/Skeleton'
import ChevronLeftIcon from '@/ui-cvi/components/dxp-icons/system/ChevronLeftIcon'
import ChevronRightIcon from '@/ui-cvi/components/dxp-icons/system/ChevronRightIcon'

// Mirrors the Filters layout so the real filters can swap in without the page shifting.
const FIELD = 'bg-semantic-global-background-white border-semantic-global-border-light flex h-10.5 items-center border'

interface Props {
  showRouteFilter?: boolean
}

const LabelSkeleton = (): React.ReactElement => (
  <div className="flex h-6 items-center">
    <Skeleton className="h-4 w-30" />
  </div>
)

export const FiltersSkeleton = ({ showRouteFilter }: Props): React.ReactElement => (
  <div className="md:gap-semantic-global-lg gap-semantic-global-md mt-semantic-global-md flex flex-col md:grid md:grid-cols-2">
    <div className="gap-semantic-global-2xs order-1 flex flex-1 flex-col md:col-span-1">
      <LabelSkeleton />
      <div className="gap-semantic-global-sm flex w-full items-center justify-between">
        <div className={`${FIELD} px-semantic-global-xs justify-center`}>
          <ChevronLeftIcon className="text-component-button-on-light-secondary-disabled" size="md" />
        </div>
        <div className={`${FIELD} px-semantic-global-sm w-full flex-1`}>
          <Skeleton className="h-4 w-25" />
        </div>
        <div className={`${FIELD} px-semantic-global-xs justify-center`}>
          <ChevronRightIcon className="text-component-button-on-light-secondary-disabled" size="md" />
        </div>
      </div>
    </div>

    {showRouteFilter ? (
      <div className="gap-semantic-global-2xs order-2 flex flex-1 flex-col md:order-2 md:col-span-1">
        <LabelSkeleton />
        <div className={`${FIELD} w-full justify-center`}>
          <Skeleton className="h-4 w-50" />
        </div>
      </div>
    ) : null}

    <div
      className={clsx(
        'gap-semantic-global-2xs order-3 flex flex-col',
        showRouteFilter ? 'md:order-3 md:col-span-2' : 'md:order-2 md:col-span-1'
      )}
    >
      <LabelSkeleton />
      <div className="gap-semantic-global-sm flex flex-row items-stretch">
        {Array.from({ length: 4 }).map((_, i) => (
          <div className={`${FIELD} w-full justify-center`} key={i}>
            <Skeleton className="h-4 w-12.5" />
          </div>
        ))}
      </div>
    </div>
  </div>
)
